export const PERM_OEM_USER = 'OEM_USER'
export const PERM_OEM_DASHBOARD = 'OEM_DASHBOARD'
export const PERM_OEM_ADMIN = 'OEM_ADMIN'
export const PERM_OEM_SYSADMIN = 'OEM_SYSADMIN'
export const PERM_OEM_DEMO_USER = 'OEM_DEMO_USER'
